/* global __WEB__ */
import { apiMiddleware } from 'redux-api-middleware';
import appCommunicationMiddleware from './redux/middlewares/appCommunicationMiddleware';
import navigationScrollMiddleware from './redux/middlewares/navigationScrollMiddleware';
import socketMiddleware from './redux/middlewares/socketMiddleware';
import patchApiMiddleware from './redux/middlewares/patchApiMiddleware';

export default function getMiddleWares() {
    let middlewares = [
        apiMiddleware,
        patchApiMiddleware(),
    ];

    if (__WEB__) {
        middlewares = [
            ...middlewares,
            appCommunicationMiddleware(),
            navigationScrollMiddleware(),
            socketMiddleware(),
        ];
    }

    return middlewares;
}



/** WEBPACK FOOTER **
 ** /src/shared/redux-middlewares.js
 **/